import { ChangeDetectionStrategy, Component, HostBinding, Input, NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CardContent, CardModule } from '@domains/home/card/card.component';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-home-b-section',
  templateUrl: './home-b-section.component.html',
  styleUrls: ['./home-b-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeBSectionComponent {
  @Input() title!: string;
  @Input() icon!: string;
  @Input() accentColor!: string;
  @Input() bgColor!: string;
  @Input() cardsList!: CardContent[];

  @HostBinding('attr.style')
  public get valueAsStyle(): any {
    const cssValues = `
      --accent-color: ${this.accentColor};
      --bg-color: ${this.bgColor};`;
    return this.sanitizer.bypassSecurityTrustStyle(cssValues);
  }

  trackByCard(_: number, card: CardContent): string {
    return card.title;
  }

  constructor(private readonly sanitizer: DomSanitizer) {}
}

@NgModule({
  imports: [SharedModule, CardModule],
  declarations: [HomeBSectionComponent],
  exports: [HomeBSectionComponent],
})
export class HomeBSectionModule {}
